module.exports = __webpack_public_path__ + "img/jiantou2.d28cc69e.gif";